import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import InfiniteScroll from 'redux-infinite-scroll-sf'

import HeaderTab from './HeaderTab'
import Quests from '../Quests'
import PublishedQuests from './myquests/PublishedQuests'
import NoQuests from './myquests/NoQuests'
import Sort from '../mini/Sort'

import { inQualityReview, published } from '../../utils/messages'
import { isQuestManager } from '../../utils/user'

export default class MyQuests extends Component {
  constructor(props) {
    super(props)
    this.loadMoreQuestsBound = this.loadMoreQuests.bind(this)
    this.handleSearchClickBound = this.handleSearchClick.bind(this)
  }

  render() {
    const {
      quests,
      stats,
      isLoading,
      filter,
      sort,
      handleAssignmentsClick,
      handleDraftsClick,
      handleInQualityReviewClick,
      handlePublishedClick,
      handleSortClick,
      dispatch,
      user,
      handleSearchChange,
      keywordFilter,
      clearTitleFilter,
      handleKeyPress,
      page,
      total,
      fetchQuests
    } = this.props

    return (
      <div className="myquests">
        <div className="header-tabs">
          {!isQuestManager(user) && (
            <HeaderTab
              intlLabel={
                <FormattedMessage
                  id={'MyQuests.MyQuests.AssignedToMe'}
                  defaultMessage={'Assigned to Me'}
                />
              }
              klass={`assigned-to-me-filter filter ${
                filter === 'assignments' ? 'active' : ''
              }`}
              clickHandler={handleAssignmentsClick}
              count={stats.assigned_quests_count}
            />
          )}

          <HeaderTab
            intlLabel={
              <FormattedMessage
                id={'MyQuests.MyQuests.Drafts'}
                defaultMessage={'Draft'}
              />
            }
            klass={`drafts-filter filter ${
              filter === 'drafts' ? 'active' : ''
            }`}
            clickHandler={handleDraftsClick}
            count={stats.draft_quests_count + stats.rejected_quests_count}
          />

          <HeaderTab
            intlLabel={inQualityReview}
            klass={`in-quality-review-filter filter ${
              filter === 'inQualityReview' ? 'active' : ''
            }`}
            clickHandler={handleInQualityReviewClick}
            count={stats.in_review_quests_count}
          />

          <HeaderTab
            intlLabel={published}
            klass={`published-filter filter ${
              filter === 'published' ? 'active' : ''
            }`}
            clickHandler={handlePublishedClick}
            count={stats.published_quests_count}
          />

          <Sort
            sort={sort}
            onClick={handleSortClick}
            desc="updated_at desc"
            asc="updated_at asc"
          />
        </div>

        <div id="quests-list" className={`${filter}-quests`}>
          {filter !== 'published' && isLoading && quests.length === 0 && (
            <div className="loading" />
          )}
          {filter === 'published' && (
            <PublishedQuests
              quests={quests}
              handleSearchChange={handleSearchChange}
              handleSearchClick={this.handleSearchClickBound}
              dispatch={dispatch}
              keywordFilter={keywordFilter}
              clearTitleFilter={clearTitleFilter}
              isLoading={isLoading}
              handleKeyPress={handleKeyPress}
              page={page}
              total={total}
              fetchQuests={fetchQuests}
              stats={stats}
              user={user}
            />
          )}
          {filter !== 'published' && quests && quests.length > 0 && (
            <InfiniteScroll
              items={
                <Quests
                  quests={quests}
                  dispatch={dispatch}
                  user={user}
                  navToSection={
                    filter === 'inQualityReview' ? 'questreview' : ''
                  }
                  iconHeightWidth={82}
                />
              }
              loadMore={this.loadMoreQuestsBound}
              loadingMore={isLoading}
              elementIsScrollable={false}
              showLoader={false}
            />
          )}
          {this.renderNoQuests() && (
            <NoQuests section={filter} addQuest={this.props.addQuest} />
          )}
        </div>
      </div>
    )
  }

  loadMoreQuests() {
    // Only load more quests if the size of the quest list is less than the totalquest count from the search call
    if (this.props.quests.length < this.props.total) {
      this.props.fetchQuests(this.props.page + 1, false)
    }
  }

  renderNoQuests() {
    const { isLoading, quests, filter, keywordFilter } = this.props
    return (
      !isLoading &&
      quests.length === 0 &&
      (filter !== 'published' ||
        (filter === 'published' && keywordFilter.length === 0))
    )
  }

  handleSearchClick(value) {
    this.props.handleSearchClick(value)
  }

  handleKeyPress(e, value) {
    this.props.handleKeyPress(e, value)
  }
}

MyQuests.propTypes = {
  quests: PropTypes.array,
  stats: PropTypes.object,
  isLoading: PropTypes.bool.isRequired,
  filter: PropTypes.string.isRequired,
  sort: PropTypes.string.isRequired,
  handleAssignmentsClick: PropTypes.func,
  handleDraftsClick: PropTypes.func,
  handleInQualityReviewClick: PropTypes.func,
  handlePublishedClick: PropTypes.func,
  handleSortClick: PropTypes.func,
  fetchQuests: PropTypes.func.isRequired,
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  handleSearchClick: PropTypes.func.isRequired,
  keywordFilter: PropTypes.string,
  clearTitleFilter: PropTypes.func.isRequired,
  handleKeyPress: PropTypes.func.isRequired,
  page: PropTypes.number,
  total: PropTypes.number,
  addQuest: PropTypes.func.isRequired
}



// WEBPACK FOOTER //
// ./src/components/myquests/MyQuests.js